import { XploraApp } from './src/components/ui/root-wrapper';

export const wrapRootElement = XploraApp;
